import { Routes, Route, Navigate } from "react-router-dom";
import PageTracker from "./components/PageTracker.jsx";
import Layout from "./components/Layout.jsx";
import Home from "./pages/Home.jsx";
import Chat from "./pages/Chat.jsx";
import ImageGen from "./pages/ImageGen.jsx";
import ImageStudio from "./pages/ImageStudio.jsx";
import VideoGen from "./pages/VideoGen.jsx";
import Marketing from "./pages/Marketing.jsx";
import CodeEditor from "./pages/CodeEditor.jsx";
import TextToSpeech from "./pages/TextToSpeech.jsx";
import VideoStudio from "./pages/VideoStudio.jsx";
import ShortsStudio from "./pages/ShortsStudio.jsx";
import Model3DStudio from "./pages/Model3DStudio.jsx";
import About from "./pages/About.jsx";

export default function App() {
  return (
    <>
      <PageTracker />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/marketing" element={<Marketing />} />
          <Route path="/image" element={<ImageGen />} />
          <Route path="/image-studio" element={<ImageStudio />} />
          <Route path="/video" element={<VideoGen />} />
          <Route path="/tts" element={<TextToSpeech />} />
          <Route path="/studio" element={<VideoStudio />} />
          <Route path="/shorts" element={<ShortsStudio />} />
          <Route path="/model3d" element={<Model3DStudio />} />
          <Route path="/code" element={<CodeEditor />} />
          <Route path="/about" element={<About />} />
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/billing" element={<Navigate to="/" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </>
  );
}
